import { useQuery } from "@tanstack/react-query";
import useRevenue from "../utils/useRevenue";

export default function useSellersData({ enabled, start_date, end_date }) {
  const { getSellers } = useRevenue();

  const { data, isLoading, error } = useQuery({
    queryKey: ["sellers", start_date, end_date],
    queryFn: () => getSellers({ start_date, end_date }),
    enabled: !!enabled && !!start_date && !!end_date,
  });

  const sellers = data?.data?.sellers || [];
  const formattedData = sellers.length
    ? [
        { label: "Todos", value: "all" },
        ...sellers.map((s) => ({
          label: s.nome,
          value: s.cod,
        })),
      ]
    : [];

  return { data: formattedData, isLoading, error };
}
